// File: src/pages/Home.jsx
import React from "react";
import HeroSection from "../components/home/HeroSection";
import ExploreBar from "../components/home/ExploreBar";
import FeaturedCars from "../components/home/FeaturedCars";
import RecentlyViewedCars     from "../components/home/RecentlyViewedCars"; 
import DualCTASection from "../components/home/DualCTASection";
import PopularBrands from "../components/home/PopularBrands";
import HowItWorks from "../components/home/HowItWorks";
import ValueAddedServices from "../components/home/ValueAddedServices";
import TrustStats from "../components/home/TrustStats";
import ExploreByBodyType   from "../components/home/ExploreByBodyType";
import CarYugoBenefits    from "../components/home/CarYugoBenefits"
import "../styles/Home.css";

const Home = () => {
  return (
    <div className="home-page">
      {/* ── Spinny-style filter bar — sticky below navbar ── */}
      <ExploreBar />

      {/* Hero with search and primary CTAs */}
      <HeroSection />

      {/* ── NEW: Buy/Sell benefits section (Spinny-style) ── */}
      <CarYugoBenefits />

      {/* ✅ Recently Viewed Cars — shows only when localStorage has entries */}
      <RecentlyViewedCars />
 
      {/* Featured premium cars */}
      <FeaturedCars />

      {/* Buy vs Sell comparison section */}
      <DualCTASection />

      {/* ── Explore by Body Type — Spinny style (NEW) ── */}
      <ExploreByBodyType />

      {/* Popular brands quick navigation */}
      <PopularBrands />

      {/* Simplified how it works (3-4 steps) */}
      <HowItWorks simplified={true} />

      {/* Finance, Insurance, Warranty services */}
      <ValueAddedServices />

      {/* Trust indicators and statistics */}
      <TrustStats />
    </div>
  );
};

export default Home;